import { resolveGifEnc } from "./resolve-gif-enc";

export const GIFENC = resolveGifEnc();
